var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatar5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.91268 20.397L1.91269 20.3968C2.02637 18.5022 2.71752 11.5836 8.56571 6.42865C13.8394 1.78007 19.9705 1.49556 21.7759 1.4419C30.1407 1.19382 39.4204 5.82791 43.3973 14.4001C47.5637 23.3808 43.7053 31.9177 42.8452 33.8056C41.6497 36.4296 38.2718 43.716 30.7432 45.9141C25.6697 47.3955 20.8076 45.9479 16.858 43.755C12.9129 41.5646 10.0522 38.7226 9.10737 37.7322C7.31308 35.8511 1.36153 29.5675 1.91268 20.397Z",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar5);
export default __webpack_public_path__ + "static/media/avatar5.55165a46.svg";
export { ForwardRef as ReactComponent };